export default __webpack_public_path__ + "static/media/Jama-Masjid-1.a617381f.jpg";